import React, { useState, useMemo } from 'react';
import {
    Table,
    Button,
    Container,
    Row,
    Col,
    Modal,
    Pagination,
    Form,
} from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { FaEdit, FaTrash } from 'react-icons/fa';


const LicenseTable = () => {
    const [showModal, setShowModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [expiryFilter, setExpiryFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const today = new Date();
    const [selectedItem, setSelectedItem] = useState(null);
    const [formData, setFormData] = useState({
        transportNumber: '',
        licenseNumber: '',
        expiryDate: '',
        comment: '',
        price: '',
        file: null,
    });


    const getDayDifference = (expiryDate) => {
        return Math.ceil((new Date(expiryDate) - today) / (1000 * 60 * 60 * 24));
    };

    const getColorClass = (daysLeft) => {
        if (daysLeft < 0) return 'text-danger fw-bold';
        if (daysLeft < 7) return 'text-warning fw-bold';
        return 'text-success fw-bold';
    };

    const licenses = [
        {
            id: 1,
            transportNumber: '01 A 234 BC',
            licenseNumber: 'LIC-123456',
            expiryDate: '2024-06-20',
            comment: 'Yillik',
            price: "500 000 so'm",
        },
        {
            id: 2,
            transportNumber: '10 B 987 ZZ',
            licenseNumber: 'LIC-654321',
            expiryDate: '2025-12-31',
            comment: 'Yangi',
            price: "600 000 so'm",
        },
        {
            id: 3,
            transportNumber: '90 C 111 AA',
            licenseNumber: 'LIC-789101',
            expiryDate: '2024-06-28',
            comment: 'Ikkilik',
            price: "450 000 so'm",
        },
        // boshqa test datalar istasangiz ko‘paytiring
    ];

    const filteredLicenses = useMemo(() => {
        return licenses
            .filter((item) => {
                const search = searchTerm.toLowerCase();
                return (
                    item.transportNumber.toLowerCase().includes(search) ||
                    item.licenseNumber.toLowerCase().includes(search) ||
                    item.comment.toLowerCase().includes(search)
                );
            })
            .filter((item) => {
                const daysLeft = getDayDifference(item.expiryDate);
                if (expiryFilter === 'expired') return daysLeft < 0;
                if (expiryFilter === 'short') return daysLeft >= 0 && daysLeft < 7;
                return true;
            })
            .sort((a, b) => {
                const aDate = new Date(a.expiryDate);
                const bDate = new Date(b.expiryDate);
                return sortOrder === 'asc' ? aDate - bDate : bDate - aDate;
            });
    }, [searchTerm, sortOrder, expiryFilter]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredLicenses.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredLicenses.length / itemsPerPage);

    const handleAddClick = () => setShowModal(true);

    return (
        <Container>
            <Row className="mb-3 align-items-center">
                <Col md={4}>
                    <Form.Control
                        type="text"
                        placeholder="Qidirish: mashina, litsenziya raqami, izoh..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <Form.Select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="asc">Tugash muddati (yaqin avval)</option>
                        <option value="desc">Tugash muddati (uzoq avval)</option>
                    </Form.Select>
                </Col>
                <Col md={3}>
                    <Form.Select
                        value={expiryFilter}
                        onChange={(e) => setExpiryFilter(e.target.value)}
                    >
                        <option value="all">Hammasi</option>
                        <option value="expired">Faqat muddati o‘tganlar</option>
                        <option value="short">Kam qolganlar (&lt; 7 kun)</option>
                    </Form.Select>
                </Col>
                <Col className="text-end">
                    <Button variant="primary" onClick={handleAddClick}>
                        <FaPlus /> Qo‘shish
                    </Button>
                </Col>
            </Row>

            <Table striped bordered hover responsive>
                <thead className="table-dark">
                <tr>
                    <th>#</th>
                    <th>Transport raqam</th>
                    <th>Litsenziya raqami</th>
                    <th>Muddati</th>
                    <th>Kun farqi</th>
                    <th>Izoh</th>
                    <th>Narx</th>
                    <th>Amallar</th> {/* YANGI USTUN */}
                </tr>
                </thead>
                <tbody>
                {currentItems.map((item, index) => {
                    const daysLeft = getDayDifference(item.expiryDate);
                    return (
                        <tr key={item.id}>
                            <td>{indexOfFirstItem + index + 1}</td>
                            <td>{item.transportNumber}</td>
                            <td>{item.licenseNumber}</td>
                            <td>{item.expiryDate}</td>
                            <td className={getColorClass(daysLeft)}>{daysLeft}</td>
                            <td>{item.comment}</td>
                            <td>{item.price}</td>
                            <td>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => {
                                        setSelectedItem(item);
                                        setFormData({
                                            transportNumber: item.transportNumber,
                                            licenseNumber: item.licenseNumber,
                                            expiryDate: item.expiryDate,
                                            comment: item.comment,
                                            price: item.price,
                                            file: null,
                                        });
                                        setShowModal(true);
                                    }}

                                >
                                    <FaEdit/>
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => {

                                    }}
                                >
                                    <FaTrash/>
                                </Button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>

            <div className="d-flex justify-content-center">
                <Pagination>
                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                            key={index}
                            active={index + 1 === currentPage}
                            onClick={() => setCurrentPage(index + 1)}
                        >
                            {index + 1}
                        </Pagination.Item>
                    ))}
                </Pagination>
            </div>

            {/*<Modal show={showModal} onHide={() => setShowModal(false)} centered>*/}
            {/*    <Modal.Header closeButton>*/}
            {/*        <Modal.Title>Yangi litsenziya qo‘shish</Modal.Title>*/}
            {/*    </Modal.Header>*/}
            {/*    <Modal.Body>*/}
            {/*        <p>Bu yerga forma keyin qo‘shiladi...</p>*/}
            {/*    </Modal.Body>*/}
            {/*</Modal>*/}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered style={{ zIndex: 2000 }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedItem ? 'Litsenziyani tahrirlash' : 'Yangi litsenziya qo‘shish'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Transport raqami</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.transportNumber}
                                onChange={(e) =>
                                    setFormData({ ...formData, transportNumber: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Litsenziya raqami</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.licenseNumber}
                                onChange={(e) =>
                                    setFormData({ ...formData, licenseNumber: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Muddati</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.expiryDate}
                                onChange={(e) =>
                                    setFormData({ ...formData, expiryDate: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Izoh</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={formData.comment}
                                onChange={(e) =>
                                    setFormData({ ...formData, comment: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Narx</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.price}
                                onChange={(e) =>
                                    setFormData({ ...formData, price: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Fayl tanlash</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) =>
                                    setFormData({ ...formData, file: e.target.files[0] })
                                }
                            />
                        </Form.Group>

                        <div className="text-end">
                            <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">
                                Bekor qilish
                            </Button>
                            <Button variant="primary" onClick={() => console.log('Saqlash', formData)}>
                                Saqlash
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

        </Container>
    );
};

export default LicenseTable;
